import React from "react";
import { Autocomplete, TextField, Chip } from "@mui/material";
import { dropdownStyles } from "../Inputs/AutoCompleteDropdown";
import { HelperError, Label } from "../Inputs/ShortTextInput";
import CloseIcon from '@mui/icons-material/Close';




const chipStyles = {
  backgroundColor: "var(--bg-input-secondary)",
  border: "1px solid",
  borderColor: "color-mix(in srgb, var(--border-input) 30%, transparent 50%)",
  padding: "0 0px",
  fontSize: "var(--font-size-primary)",
  color: "var(--text-primary)", // Optional: consistent text color
  "& .MuiChip-deleteIcon": {
    color: "var(--icon-muted)",
    "&:hover": {
      color: "var(--icon-hover)",
    }
  }
};

const TagDropdownInput = ({
  data,
  selectedItems,
  placeholder,
  onChange,
  id,
  required,
  label,
  error,
  helperText,
  className
}) => {
  return (
    <div className={className}>
      {label && <Label id={id} required={required} label={label} />}
      <Autocomplete
        disablePortal
        multiple
        options={data} // Pass data as options
        getOptionLabel={(option) => option.name} // Display member name in suggestions
        value={selectedItems}
        onChange={onChange}
        sx={dropdownStyles}
        isOptionEqualToValue={(option, value) => option.id === value.id} // Avoid duplicate selections
        renderTags={()=> null} // Disable default tag rendering
        renderInput={(params) => (
          <TextField
            {...params}
            variant="outlined"
            error={error}
            placeholder={placeholder}
            key={params.id}
          />
        )}
      />

      {selectedItems.length > 0 && <div className="mt-2 d-flex flex-wrap gap-1">
      {selectedItems?.map((option, index) => (
            <Chip
              key={option.id}
              label={option.name}
              sx={chipStyles}
              deleteIcon={<CloseIcon style={{ width: 16, height: 16 }}/>}
              onDelete={(event) => {
                const newSelection = selectedItems.filter(
                  (item) => item.id !== option.id
                );
                onChange(event, newSelection); // simulate autocomplete onChange
              }}
            />
          ))}
      </div>}

      {(helperText || error) && <HelperError id={id} error={error} helperText={helperText}/>}
    </div>
  );
};

export default TagDropdownInput;
